module.exports = __webpack_public_path__ + "static/media/zero_to-one.9b910b2f.png";